import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";

const Header = ({ darkMode, onToggleDark }) => {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();

  if (location.pathname === "/login") return null;

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/90">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex min-w-0 items-center">
          <img
            src="/logo.png"
            alt="Kia лиды"
            className="mr-3 h-8 w-auto shrink-0"
          />
          <div className="min-w-0">
            <h1 className="truncate text-lg font-semibold text-slate-950 dark:text-white sm:text-xl">
              Kia лиды
            </h1>
            <p className="hidden text-sm text-slate-500 dark:text-slate-400 sm:block">
              Аналитика лидов, качества и диалогов
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onToggleDark}
            className="inline-flex h-9 items-center rounded-lg border border-slate-300 px-3 text-xs font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-900/20 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {darkMode ? "Светлая" : "Темная"}
          </button>

          {isAuthenticated && (
            <button
              type="button"
              onClick={logout}
              className="inline-flex h-9 items-center rounded-lg bg-slate-950 px-3 text-xs font-semibold text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900/20 dark:bg-slate-100 dark:text-slate-950 dark:hover:bg-white"
            >
              Выйти
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

const AppShell = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    setDarkMode(window.localStorage.getItem("leadDashboard.darkMode") === "true");
  }, []);

  useEffect(() => {
    window.localStorage.setItem("leadDashboard.darkMode", darkMode ? "true" : "false");
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 transition-colors dark:bg-slate-950 dark:text-slate-100">
      <Header darkMode={darkMode} onToggleDark={() => setDarkMode((value) => !value)} />
      <main className="mx-auto max-w-[1600px] px-4 py-5 sm:px-6 lg:px-8">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
